__turbopack_context__.v({
  "schedule": "schedule-section-module-scss-module__oszW2q__schedule",
  "schedule__hdr": "schedule-section-module-scss-module__oszW2q__schedule__hdr",
  "schedule__hdr__btn": "schedule-section-module-scss-module__oszW2q__schedule__hdr__btn",
  "schedule__iframe": "schedule-section-module-scss-module__oszW2q__schedule__iframe",
});
